var ue = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
};
var u = (t, e, n) => (ue(t, e, "read from private field"), n ? n.call(t) : e.get(t)), h = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, S = (t, e, n, s) => (ue(t, e, "write to private field"), s ? s.call(t, n) : e.set(t, n), n);
var o = (t, e, n) => (ue(t, e, "access private method"), n);
const w = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), Y = Symbol("anyProducer"), Ee = Promise.resolve(), Z = Symbol("listenerAdded"), _ = Symbol("listenerRemoved");
let N = !1, ae = !1;
function k(t) {
  if (typeof t != "string" && typeof t != "symbol" && typeof t != "number")
    throw new TypeError("`eventName` must be a string, symbol, or number");
}
function Q(t) {
  if (typeof t != "function")
    throw new TypeError("listener must be a function");
}
function v(t, e) {
  const n = A.get(t);
  if (n.has(e))
    return n.get(e);
}
function $(t, e) {
  const n = typeof e == "string" || typeof e == "symbol" || typeof e == "number" ? e : Y, s = M.get(t);
  if (s.has(n))
    return s.get(n);
}
function ze(t, e, n) {
  const s = M.get(t);
  if (s.has(e))
    for (const i of s.get(e))
      i.enqueue(n);
  if (s.has(Y)) {
    const i = Promise.all([e, n]);
    for (const c of s.get(Y))
      c.enqueue(i);
  }
}
function xe(t, e) {
  e = Array.isArray(e) ? e : [e];
  let n = !1, s = () => {
  }, i = [];
  const c = {
    enqueue(r) {
      i.push(r), s();
    },
    finish() {
      n = !0, s();
    }
  };
  for (const r of e) {
    let a = $(t, r);
    a || (a = /* @__PURE__ */ new Set(), M.get(t).set(r, a)), a.add(c);
  }
  return {
    async next() {
      return i ? i.length === 0 ? n ? (i = void 0, this.next()) : (await new Promise((r) => {
        s = r;
      }), this.next()) : {
        done: !1,
        value: await i.shift()
      } : { done: !0 };
    },
    async return(r) {
      i = void 0;
      for (const a of e) {
        const T = $(t, a);
        T && (T.delete(c), T.size === 0 && M.get(t).delete(a));
      }
      return s(), arguments.length > 0 ? { done: !0, value: await r } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function Ke(t) {
  if (t === void 0)
    return Te;
  if (!Array.isArray(t))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const e of t)
    if (!Te.includes(e))
      throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  return t;
}
const m = (t) => t === Z || t === _;
function J(t, e, n) {
  if (m(e))
    try {
      N = !0, t.emit(e, n);
    } finally {
      N = !1;
    }
}
class K {
  static mixin(e, n) {
    return n = Ke(n), (s) => {
      if (typeof s != "function")
        throw new TypeError("`target` must be function");
      for (const r of n)
        if (s.prototype[r] !== void 0)
          throw new Error(`The property \`${r}\` already exists on \`target\``);
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new K()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const c = (r) => function(...a) {
        return this[e][r](...a);
      };
      for (const r of n)
        Object.defineProperty(s.prototype, r, {
          enumerable: !1,
          value: c(r)
        });
      return s;
    };
  }
  static get isDebugEnabled() {
    var n;
    if (typeof ((n = globalThis.process) == null ? void 0 : n.env) != "object")
      return ae;
    const { env: e } = globalThis.process ?? { env: {} };
    return e.DEBUG === "emittery" || e.DEBUG === "*" || ae;
  }
  static set isDebugEnabled(e) {
    ae = e;
  }
  constructor(e = {}) {
    w.set(this, /* @__PURE__ */ new Set()), A.set(this, /* @__PURE__ */ new Map()), M.set(this, /* @__PURE__ */ new Map()), M.get(this).set(Y, /* @__PURE__ */ new Set()), this.debug = e.debug ?? {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (n, s, i, c) => {
      try {
        c = JSON.stringify(c);
      } catch {
        c = `Object with the following keys failed to stringify: ${Object.keys(c).join(",")}`;
      }
      (typeof i == "symbol" || typeof i == "number") && (i = i.toString());
      const r = /* @__PURE__ */ new Date(), a = `${r.getHours()}:${r.getMinutes()}:${r.getSeconds()}.${r.getMilliseconds()}`;
      console.log(`[${a}][emittery:${n}][${s}] Event Name: ${i}
	data: ${c}`);
    });
  }
  logIfDebugEnabled(e, n, s) {
    (K.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, n, s);
  }
  on(e, n) {
    Q(n), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      k(s);
      let i = v(this, s);
      i || (i = /* @__PURE__ */ new Set(), A.get(this).set(s, i)), i.add(n), this.logIfDebugEnabled("subscribe", s, void 0), m(s) || J(this, Z, { eventName: s, listener: n });
    }
    return this.off.bind(this, e, n);
  }
  off(e, n) {
    Q(n), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      k(s);
      const i = v(this, s);
      i && (i.delete(n), i.size === 0 && A.get(this).delete(s)), this.logIfDebugEnabled("unsubscribe", s, void 0), m(s) || J(this, _, { eventName: s, listener: n });
    }
  }
  once(e) {
    let n;
    const s = new Promise((i) => {
      n = this.on(e, (c) => {
        n(), i(c);
      });
    });
    return s.off = n, s;
  }
  events(e) {
    e = Array.isArray(e) ? e : [e];
    for (const n of e)
      k(n);
    return xe(this, e);
  }
  async emit(e, n) {
    if (k(e), m(e) && !N)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emit", e, n), ze(this, e, n);
    const s = v(this, e) ?? /* @__PURE__ */ new Set(), i = w.get(this), c = [...s], r = m(e) ? [] : [...i];
    await Ee, await Promise.all([
      ...c.map(async (a) => {
        if (s.has(a))
          return a(n);
      }),
      ...r.map(async (a) => {
        if (i.has(a))
          return a(e, n);
      })
    ]);
  }
  async emitSerial(e, n) {
    if (k(e), m(e) && !N)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emitSerial", e, n);
    const s = v(this, e) ?? /* @__PURE__ */ new Set(), i = w.get(this), c = [...s], r = [...i];
    await Ee;
    for (const a of c)
      s.has(a) && await a(n);
    for (const a of r)
      i.has(a) && await a(e, n);
  }
  onAny(e) {
    return Q(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), w.get(this).add(e), J(this, Z, { listener: e }), this.offAny.bind(this, e);
  }
  anyEvent() {
    return xe(this);
  }
  offAny(e) {
    Q(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), J(this, _, { listener: e }), w.get(this).delete(e);
  }
  clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (const n of e)
      if (this.logIfDebugEnabled("clear", n, void 0), typeof n == "string" || typeof n == "symbol" || typeof n == "number") {
        const s = v(this, n);
        s && s.clear();
        const i = $(this, n);
        if (i) {
          for (const c of i)
            c.finish();
          i.clear();
        }
      } else {
        w.get(this).clear();
        for (const [s, i] of A.get(this).entries())
          i.clear(), A.get(this).delete(s);
        for (const [s, i] of M.get(this).entries()) {
          for (const c of i)
            c.finish();
          i.clear(), M.get(this).delete(s);
        }
      }
  }
  listenerCount(e) {
    var s, i, c;
    e = Array.isArray(e) ? e : [e];
    let n = 0;
    for (const r of e) {
      if (typeof r == "string") {
        n += w.get(this).size + (((s = v(this, r)) == null ? void 0 : s.size) ?? 0) + (((i = $(this, r)) == null ? void 0 : i.size) ?? 0) + (((c = $(this)) == null ? void 0 : c.size) ?? 0);
        continue;
      }
      typeof r < "u" && k(r), n += w.get(this).size;
      for (const a of A.get(this).values())
        n += a.size;
      for (const a of M.get(this).values())
        n += a.size;
    }
    return n;
  }
  bindMethods(e, n) {
    if (typeof e != "object" || e === null)
      throw new TypeError("`target` must be an object");
    n = Ke(n);
    for (const s of n) {
      if (e[s] !== void 0)
        throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  }
}
const Te = Object.getOwnPropertyNames(K.prototype).filter((t) => t !== "constructor");
Object.defineProperty(K, "listenerAdded", {
  value: Z,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(K, "listenerRemoved", {
  value: _,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
function V(t) {
  return typeof t == "object" && t !== null;
}
function Se(t, e) {
  return e in t;
}
function l(t) {
  return V(t) && Se(t, "type");
}
function We(t) {
  return V(t) && typeof t.uuid == "string";
}
function Ge(t) {
  return V(t) && typeof t.ackedUuid == "string";
}
function Fe(t) {
  return V(t) && Se(t, "message");
}
function Ve(t) {
  return V(t) && typeof t.eventName == "string";
}
const Qe = "activate";
function Je(t) {
  return l(t) && t.type === Qe;
}
const Xe = "app";
function Ye(t) {
  return l(t) && t.type === Xe && "source" in t && "message" in t;
}
const Ze = "app-ready";
function _e(t) {
  return l(t) && t.type === Ze;
}
const Ne = "close-side-panel";
function et(t) {
  return l(t) && t.type === Ne;
}
const tt = "deactivate";
function nt(t) {
  return l(t) && t.type === tt;
}
const ke = "dispatch-custom-event";
function st(t) {
  return l(t) && t.type === ke && Ve(t);
}
const it = "do-not-disturb";
function ot(t) {
  return l(t) && (t == null ? void 0 : t.type) === it;
}
const he = "health-check";
function rt(t) {
  return l(t) && t.type === he;
}
const ct = "keyboard-command";
function ut(t) {
  return l(t) && t.type === ct && "code" in t;
}
const at = "logout";
function ht(t) {
  return l(t) && t.type === at;
}
const lt = "module-ready";
function ft(t) {
  return l(t) && t.type === lt && "module" in t;
}
const dt = "navigate";
function pt(t) {
  return l(t) && t.type === dt;
}
const gt = "notification-clicked";
function yt(t) {
  return l(t) && t.type === gt;
}
const bt = "open-app";
function Mt(t) {
  return l(t) && t.type === bt && "name" in t;
}
const wt = "open-multi-login";
function At(t) {
  return l(t) && t.type === wt;
}
const Ct = "recreate";
function Et(t) {
  return l(t) && t.type === Ct;
}
const xt = "refresh";
function Kt(t) {
  return l(t) && t.type === xt;
}
const Tt = "settings-updated";
function St(t) {
  return l(t) && t.type === Tt && "newValue" in t;
}
const kt = "show-native-app-install";
function vt(t) {
  return l(t) && t.type === kt;
}
const mt = "show-notification";
function Bt(t) {
  return l(t) && t.type === mt && "title" in t && "body" in t && "icon" in t;
}
const ve = "ACK";
function me(t) {
  return l(t) && t.type === ve && Ge(t) && !!t.ackedUuid;
}
const Be = "BRIDGE:ACTIVATED";
function Pt(t) {
  return l(t) && t.type === Be;
}
const Pe = "BRIDGE:CONNECTED";
function Dt(t) {
  return l(t) && t.type === Pe;
}
const De = "HEARTBEAT";
function Rt(t) {
  return l(t) && t.type === De;
}
function R(t) {
  return me(t) || Rt(t) || Pt(t) || Dt(t);
}
const $t = "title-change";
function jt(t) {
  return l(t) && t.type === $t;
}
const Ot = "to-app";
function Lt(t) {
  return l(t) && t.type === Ot && "target" in t && "message" in t;
}
const It = "update-badge";
function Ut(t) {
  return l(t) && t.type === It && "value" in t;
}
function Ht(t) {
  if (!Fe(t.data) || !We(t.data) || t.data.uuid === "")
    return !1;
  const { message: e } = t.data;
  return R(e) || rt(e) || Je(e) || nt(e) || pt(e) || jt(e) || _e(e) || ft(e) || Kt(e) || Lt(e) || Ye(e) || vt(e) || Mt(e) || At(e) || ut(e) || Et(e) || Ut(e) || et(e) || st(e) || St(e) || Bt(e) || yt(e) || ht(e) || ot(e);
}
const Re = "KSUITE-BRIDGE:connection-establish";
function qt(t) {
  var e;
  return (t == null ? void 0 : t.data) === Re && ((e = t.ports) == null ? void 0 : e.length) > 0;
}
const $e = "KSUITE-BRIDGE:connection-request";
function zt(t) {
  return (t == null ? void 0 : t.data) === $e;
}
function X() {
  let t = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const n = (t + Math.random() * 16) % 16 | 0;
    return t = Math.floor(t / 16), (e === "x" ? n : n & 3 | 8).toString(16);
  });
}
var B, j, le, y, ee, je, te, Oe, ne, Le, O, fe, P, C, E, D, L, de, f, x, se, I, pe, ie, Ie, U, ge, H, ye, oe, Ue, q, be, z, Me, W, we, re, He, ce, qe, d, g, p, b, G, Ae, F, Ce;
class Ft {
  constructor(e = { debug: !1 }) {
    h(this, j);
    /**
     * Process postMessages if the bridge is not already connected.
     * @param messageEvent
     */
    h(this, ee);
    /**
     * Sends a ConnectionRequestMessage postMessage to the parent window to trigger unconnected host
     * bridge to send a ConnectionEstablishMessage.
     */
    h(this, te);
    /**
     * Respond to a ConnectionRequestMessage with a ConnectionEstablishMessage along with a channel
     * port.
     */
    h(this, ne);
    /**
     * Binds the given port to the bridge channel port, stops listening to post messages and starts
     * processing queued messages.
     * @param port
     */
    h(this, O);
    /**
     * Process the messages in `incomingMessageQueue` and `outgoingMessageQueue`. Process one message
     * by JS cycle to avoid clogging the thread.
     */
    h(this, L);
    /**
     * Sends the given wrapped message to all channels. If no channel is ready, the message is added
     * to the buffer for delayed processing. For non-system messages, each channel is "health checked"
     * before actually sending and dead channels are disconnected.
     */
    h(this, I);
    /**
     * Sends a `HeartbeatMessage` to a channel in `this.channelPorts` to see if it is still there.
     * `HeartbeatMessage` are processed only within the bridge so the timeout for the message to be
     * ack is set very low.
     */
    h(this, ie);
    /**
     * Sends a bridgeMessage to a channel in `this.channelPorts`. Sets a resolve callback in
     * `this.activeMessageResolvers` for this specific bridgeMessage or rejects after given
     * `messageTimeout` ms.
     *
     * `messageTimeout` defaults to `6_000`.
     */
    h(this, U);
    /**
     * Send a bridgeMessage to a specific channel.
     */
    h(this, H);
    /**
     * Process incoming channel messages if they are proper bridge messages.
     */
    h(this, oe);
    /**
     * Inject the the given message in the internal event bus or queue it if bridge not active.
     */
    h(this, q);
    /**
     * Acknowledge processing of message with a certain uuid
     */
    h(this, z);
    // *** Built in callbacks
    /**
     * Register all callbacks defined `builtInCallBack`. Does so without duplication by trying to
     * unsubscribing them before adding them.
     */
    h(this, W);
    /**
     * Health-check response process
     *
     * @param message {HealthCheckMessage}
     */
    h(this, re);
    /**
     * Dispatch the event in given message to the document.
     *
     * @param message {DispatchCustomEventMessage}
     */
    h(this, ce);
    // *** Debugging
    /**
     * Logs generic messages with KSuite bridge name as header.
     */
    h(this, d);
    /**
     * Logs generic messages with KSuite bridge and bridgeMessage uuid as header and bridgeMessage
     * body as suffix.
     */
    h(this, p);
    /**
     * Logs the given message if the bridge has debug mode enabled.
     */
    h(this, G);
    /**
     * Returns the message's key from a `BridgeMessage`, and the id of a channel port.
     */
    h(this, F);
    /**
     * Stops the bridge from listening to message events.
     */
    h(this, B, void 0);
    /**
     * The channel ports to which the bridge sends its messages.
     */
    h(this, y, /* @__PURE__ */ new Map());
    // *** Message queuing
    h(this, P, void 0);
    /**
     * An internal buffer to store outgoing message while the bridge is not active.
     */
    h(this, C, []);
    /**
     * An internal buffer to store incoming message while the bridge is not active.
     */
    h(this, E, []);
    h(this, D, !1);
    // *** Channel messages
    /**
     * The event bus exposing divers binding methods.
     */
    h(this, f, void 0);
    /**
     * The event bus for acknowledgement messages.
     */
    h(this, x, /* @__PURE__ */ new Map());
    /**
     * The callbacks we always want to have on our instance.
     */
    h(this, se, /* @__PURE__ */ new Map([
      [he, o(this, re, He).bind(this)],
      [ke, o(this, ce, qe).bind(this)]
    ]));
    this.options = e, S(this, f, new K({
      debug: {
        name: typeof e.debug == "string" ? e.debug : "KSuiteBridge",
        enabled: !!e.debugVerbose
      }
    })), S(this, P, this.options.activateOn ?? "connected");
    const n = o(this, ee, je).bind(this);
    window.addEventListener("message", n), S(this, B, () => {
      window.removeEventListener("message", n);
    }), o(this, W, we).call(this), e.iFrame || o(this, te, Oe).call(this);
  }
  /**
   * Stops the bridge from listening to message events and removes the internal channelPort, making
   * the instance ready for garbage collection.
   */
  dispose() {
    u(this, B).call(this);
    const e = u(this, y).values();
    let n;
    for (; !(n = e.next()).done; )
      o(this, j, le).call(this, n.value);
    u(this, y).clear(), o(this, d, g).call(this, "🪦 Disposed");
  }
  // *** Connection
  /**
   * Whether the bridge has established a connexion with its counterpart.
   */
  get isConnected() {
    return this.channelPortsCount > 0;
  }
  /**
   * Number of open channel with the counterpart
   */
  get channelPortsCount() {
    return u(this, y).size;
  }
  /**
   * Whether the bridge has been enabled.
   */
  get isEnabled() {
    return u(this, D);
  }
  /**
   * Whether the bridge is connected _and_ enabled.
   */
  get isActive() {
    return this.isEnabled && this.isConnected;
  }
  /**
   * When using `'enabled'` activate strategy, marks the bridge as enabled. Has no effect in
   * `'connected'` strategy.
   */
  enable() {
    u(this, P) === "enabled" && (S(this, D, !0), o(this, L, de).call(this));
  }
  /**
   * Sends a message to the bridge target. You can specify a custom timeout duration before the
   * methods throws if you know this message is expected to take a long time processing. By default,
   * the timeout will be `this.options.messageTimeout` or  `6_000`.
   */
  sendMessage(e, n = this.options.messageTimeout ?? 6e3) {
    const s = { uuid: X(), message: e };
    return o(this, I, pe).call(this, s, n);
  }
  // *** Subscription
  /**
   * Subscribe to a given message type.
   */
  on(e, n) {
    return u(this, f).on(e, n);
  }
  /**
   * Unsubscribe a given callback by message type.
   */
  off(e, n) {
    u(this, f).off(e, n);
  }
  /**
   * Subscribe once to a given message type.
   */
  once(e) {
    return u(this, f).once(e);
  }
  /**
   * Subscribe to a buffered & ordered events iterator.
   */
  events(e) {
    return u(this, f).events(e);
  }
  /**
   * Unsubscribe all callbacks for a given type. If no type is provided, removes all callbacks from
   * all types.
   */
  allOff(e) {
    u(this, f).clearListeners(e), o(this, W, we).call(this);
  }
  /**
   * Get the registered callback number for a given type.
   * @param type
   */
  countListeners(e) {
    return u(this, f).listenerCount(e);
  }
}
B = new WeakMap(), j = new WeakSet(), le = function(e) {
  e.onmessage = null, e.onmessageerror = null, e.close();
}, y = new WeakMap(), ee = new WeakSet(), je = function(e) {
  this.options.iFrame ? zt(e) && o(this, ne, Le).call(this, this.options.iFrame) : qt(e) && !this.isConnected && o(this, O, fe).call(this, e.ports[0]);
}, te = new WeakSet(), Oe = function() {
  window.parent.postMessage($e, "*"), o(this, d, g).call(this, "🤝 ConnectionRequestMessage sent");
}, ne = new WeakSet(), Le = function(e) {
  const n = new MessageChannel();
  if (!e.contentWindow) {
    console.error("Content window is not accessible on given iframe");
    return;
  }
  o(this, O, fe).call(this, n.port1), e.contentWindow.postMessage(Re, "*", [n.port2]), o(this, d, g).call(this, "🤝 ConnectionEstablishMessage sent");
}, O = new WeakSet(), fe = function(e) {
  u(this, y).set(X(), e), e.onmessage = o(this, oe, Ue).bind(this), e.onmessageerror = (n) => {
    console.error(
      `KSuiteBridge${typeof this.options.debug == "string" ? ` [${this.options.debug}]` : ""}: Message cannot be deserialized.`
    ), console.error(n.data);
  }, o(this, d, g).call(this, "🤝 Channel connected"), u(this, f).emit(Pe, null), this.options.iFrame || u(this, B).call(this), u(this, P) === "connected" && S(this, D, !0), o(this, L, de).call(this);
}, P = new WeakMap(), C = new WeakMap(), E = new WeakMap(), D = new WeakMap(), L = new WeakSet(), de = async function() {
  if (!this.isActive)
    return;
  o(this, d, g).call(this, "⏩ Processing", u(this, E).length, "incoming and", u(this, C).length, "outgoing messages...");
  const e = [];
  for (; u(this, E).length > 0; )
    e.push(o(this, q, be).call(this, u(this, E).shift()));
  for (; u(this, C).length > 0; )
    e.push(o(this, I, pe).call(this, u(this, C).shift()));
  o(this, d, g).call(this, "💬 on BridgeActivated"), await u(this, f).emit(Be, null), await Promise.all(e);
}, f = new WeakMap(), x = new WeakMap(), se = new WeakMap(), I = new WeakSet(), pe = async function(e, n = this.options.messageTimeout ?? 6e3) {
  const s = [];
  let i = !1;
  if (this.isActive) {
    o(this, p, b).call(this, e, "✍️ Start sending message to", this.channelPortsCount, "channels");
    const c = u(this, y).entries();
    let r;
    for (; !(r = c.next()).done; ) {
      const [a, T] = r.value;
      s.push(
        o(this, ie, Ie).call(this, a).catch(() => {
          throw o(this, d, g).call(this, "🗑️ Removing dead channel..."), o(this, j, le).call(this, T), u(this, y).delete(a), new Error("Channel is dead");
        }).then(
          () => o(this, U, ge).call(this, e, a, n)
        )
      );
    }
  } else
    R(e.message) || (o(this, p, b).call(this, e, "⏸️ Bridge not active, adding message to outgoing queue"), u(this, C).push(e), i = !0, s.push(
      new Promise((c) => {
        u(this, x).set(e.uuid, c);
      })
    ));
  return Promise.allSettled(s).then(() => {
    o(this, p, b).call(this, e, "🏁 Message", i ? "finally processed" : "processed by all channels");
  });
}, ie = new WeakSet(), Ie = function(e) {
  const n = {
    uuid: X(),
    message: { type: De }
  };
  return o(this, d, g).call(this, "💓 Checking on channel", e, "..."), o(this, U, ge).call(this, n, e, 1e3);
}, U = new WeakSet(), ge = function(e, n, s = 6e3) {
  return new Promise((i, c) => {
    const r = o(this, F, Ce).call(this, e, n);
    o(this, H, ye).call(this, e, n);
    const a = setTimeout(() => {
      o(this, p, b).call(this, { uuid: r }, "⌛ Timeout"), c();
    }, s);
    u(this, x).set(r, () => {
      R(e.message) || o(this, p, b).call(this, e, "✅ Message processed by channel", n), clearTimeout(a), i();
    });
  });
}, H = new WeakSet(), ye = function(e, n) {
  var s;
  (s = u(this, y).get(n)) == null || s.postMessage({
    ...e,
    uuid: o(this, F, Ce).call(this, e, n)
  }), R(e.message) || o(this, p, b).call(this, e, "✉️ Message sent to channel", n);
}, oe = new WeakSet(), Ue = async function(e) {
  if (Ht(e))
    return o(this, q, be).call(this, e.data);
}, q = new WeakSet(), be = async function(e) {
  var i, c;
  const { uuid: n, message: s } = e;
  if (me(s)) {
    const [r] = s.ackedUuid.split(":", 1);
    return (i = u(this, x).get(r)) == null || i(), (c = u(this, x).get(s.ackedUuid)) == null ? void 0 : c();
  }
  if (R(s))
    return o(this, d, g).call(this, "❤️️ Alive"), o(this, z, Me).call(this, n);
  if (o(this, p, b).call(this, e, "📬 Message received"), !this.isActive) {
    o(this, p, b).call(this, e, "⏸️ Bridge not active, adding message to incoming queue"), u(this, E).push(e);
    return;
  }
  o(this, d, g).call(this, "💬 on Message", s), await u(this, f).emit(s.type, s), o(this, p, b).call(this, e, "☑️ Processed"), o(this, z, Me).call(this, n);
}, z = new WeakSet(), Me = function(e) {
  const n = {
    uuid: X(),
    message: { type: ve, ackedUuid: e }
  }, s = u(this, y).keys();
  let i;
  for (; !(i = s.next()).done; )
    o(this, H, ye).call(this, n, i.value);
}, W = new WeakSet(), we = function() {
  for (const [e, n] of u(this, se).entries()) {
    const s = n;
    this.off(e, s), this.on(e, s);
  }
}, re = new WeakSet(), He = function(e) {
  e.status === "ping" && this.sendMessage({
    type: he,
    status: `pong from ${location.origin}`
  });
}, ce = new WeakSet(), qe = function(e) {
  (e.selector === "window" ? window : document).dispatchEvent(
    new CustomEvent(e.eventName, { detail: e.payload })
  );
}, d = new WeakSet(), g = function(...e) {
  let n = "";
  typeof this.options.debug == "string" && (n = ` [${this.options.debug}]`), o(this, G, Ae).call(this, `%cKSuiteBridge%c${n}`, "color: #0098ff;", "color: #999;", ...e);
}, p = new WeakSet(), b = function(e, ...n) {
  let s = " ";
  typeof this.options.debug == "string" && (s = ` [${this.options.debug}] `), o(this, G, Ae).call(this, `%cKSuiteBridge%c${s}%c(${e.uuid})`, "color: #0098ff;", "color: #999;", "color: #f97316;", ...n, e.message ?? "");
}, G = new WeakSet(), Ae = function(...e) {
  this.options.debug && console.log(...e);
}, F = new WeakSet(), Ce = function(e, n) {
  return `${e.uuid}:${n}`;
};
export {
  Qe as ActivateMessageKey,
  Xe as AppMessageKey,
  Ze as AppReadyMessageKey,
  Be as BridgeActivated,
  Pe as BridgeConnected,
  Ne as CloseSidePanelMessageKey,
  Re as ConnectionEstablishMessage,
  $e as ConnectionRequestMessage,
  tt as DeactivateMessageKey,
  ke as DispatchCustomEventMessageKey,
  it as DoNotDisturbMessageKey,
  he as HealthCheckMessageKey,
  Ft as KSuiteBridge,
  ct as KeyboardCommandMessageKey,
  at as LogoutMessageKey,
  lt as ModuleReadyMessageKey,
  dt as NavigateMessageKey,
  gt as NotificationClickedMessageKey,
  bt as OpenAppMessageKey,
  wt as OpenMultiLoginMessageKey,
  Ct as RecreateMessageKey,
  xt as RefreshMessageKey,
  Tt as SettingsUpdatedMessageKey,
  kt as ShowNativeAppInstallMessageKey,
  mt as ShowNotificationMessageKey,
  $t as TitleChangeMessageKey,
  Ot as ToAppMessageKey,
  It as UpdateBadgeMessageKey,
  Je as isActivateMessage,
  Ye as isAppMessage,
  _e as isAppReadyMessage,
  Ht as isBridgeMessageEvent,
  et as isCloseSidePanelMessage,
  qt as isConnectionEstablishMessage,
  zt as isConnectionRequestMessage,
  nt as isDeactivateMessage,
  st as isDispatchCustomEventMessage,
  ot as isDoNotDisturbMessage,
  rt as isHealthCheckMessage,
  ut as isKeyboardCommandMessage,
  ht as isLogoutMessage,
  ft as isModuleReadyMessage,
  pt as isNavigateMessage,
  yt as isNotificationClickedMessage,
  Mt as isOpenAppMessage,
  At as isOpenMultiLoginMessage,
  Et as isRecreateMessage,
  Kt as isRefreshMessage,
  St as isSettingsUpdatedMessage,
  vt as isShowNativeAppInstallMessage,
  Bt as isShowNotificationMessage,
  jt as isTitleChangeMessage,
  Lt as isToAppMessage,
  Ut as isUpdateBadgeMessage
};
